import type { NavSectionData } from '@layouts/dashboard/types';

import { NavSections } from '@layouts/dashboard/components/nav-sections';

import { Logo } from '@shared/components/logo';
import { ScrollArea } from '@shared/components/ui/scroll-area';

/** Logo + sections, shared by the fixed sidebar (desktop) and the mobile sheet. */
export const NavContent = ({ data }: { data: NavSectionData[] }) => (
  <>
    <div className="pt-5 pb-2 pl-7">
      <Logo />
    </div>
    <ScrollArea className="min-h-0 flex-1">
      <NavSections data={data} />
    </ScrollArea>
  </>
);
